import { Assert } from "@seriously-rad/seriouslyrad-framework-core/Assert";
import { DataSource } from "@seriously-rad/seriouslyrad-framework-core/Data/DataSource";
import { AndExpression } from "@seriously-rad/seriouslyrad-framework-core/Expressions/AndExpression";
import { ComparisonExpression } from "@seriously-rad/seriouslyrad-framework-core/Expressions/ComparisonExpression";
import { PartialNullable } from "@seriously-rad/seriouslyrad-framework-core/Extensions";
import { Property } from "@seriously-rad/seriouslyrad-framework-core/RadObject";
import { ButtonStyleEnum } from "@seriously-rad/seriouslyrad-framework-core/Ui/Controls/ButtonStyleEnum";
import { IParameterDialog, ParameterDialog, ParameterDialogPropertyValues } from "@seriously-rad/seriouslyrad-framework-core/Ui/Controls/ParameterDialog";
import { PropertyEditorComboBoxLookupItem } from "@seriously-rad/seriouslyrad-framework-core/Ui/Controls/PropertyEditorComboBoxLookupItem";
import { PropertyEditorComboBoxYesNo } from "@seriously-rad/seriouslyrad-framework-core/Ui/Controls/PropertyEditorComboBoxYesNo";
import { NAMESPACE } from "./_Namespace";

export type IntegratedDataSetRecordFilterParameterDialogPropertyValues =
    ParameterDialogPropertyValues
    & {
    };

export type IntegratedDataSetRecordFilterParameterDialogProperties = {
    [name in keyof IntegratedDataSetRecordFilterParameterDialogPropertyValues]: Property<IntegratedDataSetRecordFilterParameterDialogPropertyValues[name]>
};

export interface IIntegratedDataSetRecordFilterParameterDialog extends IParameterDialog, IntegratedDataSetRecordFilterParameterDialogProperties
{
}

export class IntegratedDataSetRecordFilterParameterDialog extends ParameterDialog implements IIntegratedDataSetRecordFilterParameterDialog
{
    // #region Static

    public static override classNamespace = NAMESPACE + "IntegratedDataSetRecordFilterParameterDialog";
    public static override className = "IntegratedDataSetRecordFilterParameterDialog";

    // #region Overrides

    public static override createPropertyDefaults(): PartialNullable<IntegratedDataSetRecordFilterParameterDialogPropertyValues>
    {
        return {
            ...super.createPropertyDefaults(),
            ...{
                buttonStyle: ButtonStyleEnum.okCancel,
            }
        };
    }

    // #endregion

    // #endregion

    // #region Instance

    // #region Global Variables

    protected propertyEditorStatus?: PropertyEditorComboBoxLookupItem;
    protected propertyEditorIgnore?: PropertyEditorComboBoxYesNo;

    // #endregion

    // #region Constructor

    constructor(propertyValues?: PartialNullable<IntegratedDataSetRecordFilterParameterDialogPropertyValues>)
    {
        super(propertyValues);
    }

    // #endregion

    // #region Overrides

    protected override _createElement()
    {
        const
            $$element = super._createElement();

        this.propertyEditorStatus =
            new PropertyEditorComboBoxLookupItem({
                editMode: true,
                lookupType: "Integrated Data Set Record Statuses",
                propertyDisplayName: "Status"
            })
                .appendTo(this);

        this.propertyEditorIgnore =
            new PropertyEditorComboBoxYesNo({
                editMode: true,
                propertyDisplayName: "Ignore?"
            })
                .appendTo(this);

        return $$element;
    }
    public override createExpression()
    {
        Assert.isNotNullOrUndefined(this.propertyEditorStatus, "this.propertyEditorStatus");
        Assert.isNotNullOrUndefined(this.propertyEditorIgnore, "this.propertyEditorIgnore");

        const
            expression = new AndExpression(),
            status = this.propertyEditorStatus.value.get(),
            ignore = this.propertyEditorIgnore.value.get();

        if (status)
            expression.add(new ComparisonExpression({ path: "statusLookupItemId", value: status }));

        if (ignore)
            expression.add(new ComparisonExpression({ path: "ignore", value: ignore }));

        return expression.count() > 0 ? expression : null;
    }
    public override openAsync()
    {
        Assert.isNotNullOrUndefined(this.propertyEditorStatus, "this.propertyEditorStatus");
        Assert.isNotNullOrUndefined(this.propertyEditorIgnore, "this.propertyEditorIgnore");

        const
            dataSource = new DataSource({ data: {} });

        this.propertyEditorStatus.dataSource.set(dataSource);
        this.propertyEditorIgnore.dataSource.set(dataSource);

        return super.openAsync();
    }

    // #endregion

    // #endregion
}

